import type { ViewerRole } from './types';

/** Destination du nom/avatar d'un élève dans le Feed (null = pas de lien). */
export type StudentLink =
  | { to: '/tutor/students/$studentId'; params: { studentId: string } }
  | { to: '/parent/children' }
  | { to: '/profile' };

/**
 * Page « élève » selon qui regarde :
 * - l'élève lui-même → son profil ;
 * - un prof → la fiche élève ;
 * - un parent → la page « Mes enfants » ;
 * - un camarade (ou joueur) → aucun lien : il n'existe pas de page élève publique.
 */
export function studentLinkFor(
  viewerRole: ViewerRole,
  viewerId: string | null | undefined,
  studentId: string,
): StudentLink | null {
  if (viewerId && viewerId === studentId) return { to: '/profile' };
  if (viewerRole === 'tutor') return { to: '/tutor/students/$studentId', params: { studentId } };
  if (viewerRole === 'parent') return { to: '/parent/children' };
  return null;
}
